import React from 'react';
import { AppBar, Toolbar, Typography } from '@material-ui/core';
import { observer, inject } from 'mobx-react';
import Menu from 'components/Menu/Menu';
import TemplateMenu from 'components/TemplateMenu/TemplateMenu';
import text from 'texts/translations';
import LanguageMenu from '../LanguageMenu/LanguageMenu';
import Translation from '../Translation/Translation';

@inject('customerCaseStore')
@inject('languageStore')
@observer
export default class Header extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <AppBar position="static" className="primary">
          <Toolbar>
            {this.props.customerCaseStore.currentUser ? <Menu /> : ''}
            <Typography style={{flexGrow: 1}} variant="title" color="inherit" className="mk">
              <Translation>header.mainPage</Translation>
            </Typography>

            <LanguageMenu activeLanguage={this.props.languageStore.language}/>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx